import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const downloadCarousel = ( userId ) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadCarousel",
          params : {"userId": userId},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadRating = ( requestIdInt, userId, pageNumber, pageSize ) => {
    return new Promise((resolve, reject) => {
        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadRating",
          params : {'requestIdInt': requestIdInt, 'userId': userId, 'pageNumber': pageNumber, 'pageSize': pageSize},
          headers:  { "Content-Type": "application/json",  },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

// countryName (optional): only reviews from customers in that country. Left
// out, axios drops the param and the request is unchanged.
export const getTestimonials = ( category, pageNumber, pageSize, countryName ) => {
    return new Promise((resolve, reject) => {
        axios({
          method : "GET",
          url :  api_url + "/profile/GetTestimonials",
          params : {'category': category, 'pageNumber': pageNumber, 'pageSize': pageSize, 'countryName': countryName},
          headers:  { "Content-Type": "application/json",  },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadAbout = ( userId, stringUserId ) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadAbout",
          params : {'userId': userId, 'stringUserId': stringUserId},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadProfilePic = ( profileUserId ) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadProfilePic",
          params : {'profileUserId': profileUserId},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadAllAlbums = ( userId, stringUserId ) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadAllAlbums",
          params : {'userId': userId, 'stringUserId': stringUserId},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const addVisitCount = ( userId ) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "POST",
          url :  api_url + "/profile/AddVisitCount",
          params : {'userId': userId},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadAlbum = ( userId, albumName ) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadAlbum",
          params : {'userId': userId, 'albumName': albumName},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadAllUserId = ( ) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadAllUserId",
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const getStringUserIdFromHandleName = (handleName ) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/profile/GetStringUserIdFromHandleName",
          params : {'handleName': handleName},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const setProfileImage = ( userId, imgId ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('userId', userId);
        fdd.append('imgId', imgId);

        axios({
          method : "POST",
          url :  api_url + "/SetProfilePic",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const deleteImage = ( userId, imgId ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('userId', userId);
        fdd.append('imgId', imgId);

        axios({
          method : "POST",
          url :  api_url + "/DeleteImage",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const submitReview = ( jobIdInt, requestUserId, respondUserId, reviewComment, category, rating) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('jobIdInt', jobIdInt);
        fdd.append('requestUserId', requestUserId);
        fdd.append('respondUserId', respondUserId);
        fdd.append('reviewComment', reviewComment);
        fdd.append('category', category);
        fdd.append('rating', rating);

        axios({
          method : "POST",
          url :  api_url + "/SubmitReview",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

// serviceId (client_service) is the service being rated; each one can be
// reviewed once. The backend takes the rater from the login and the rated SP
// and category from the service; requestUserId, respondUserId and category
// are only read by builds from before Oct 2026.
export const submitJobReview = ( isSubmitReview, jobIdInt, requestUserId, respondUserId, reviewComment, category, rating, serviceId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('isSubmitReview', isSubmitReview)
        fdd.append('jobIdInt', jobIdInt);
        if (serviceId) fdd.append('serviceId', serviceId);
        fdd.append('requestUserId', requestUserId);
        fdd.append('respondUserId', respondUserId);
        fdd.append('reviewComment', reviewComment);
        fdd.append('category', category);
        fdd.append('rating', rating);

        axios({
          method : "POST",
          url :  api_url + "/JobReview",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}